module.exports = __webpack_public_path__ + "static/media/Moltres_gaussian2.d346e222.png";